module.exports = __webpack_public_path__ + "img/block6-card8.6725dfc6.svg";